// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"102":"3ffeadb6","392":"f18aeb08","631":"67521f52","849":"d0b0bb2e","878":"66f924c3"}[chunkId] + ".chunk.js";
};